<template>
  <v-dialog v-if="viewOnMapDialog" v-model="viewOnMapDialog" max-width="700" persistent>
      <v-card class="pa-4">
          <div>
              <v-card-title>
                  <h2 class="title">Search Address</h2>
              </v-card-title>

              <div class="py-4 px-6">
                <div v-if="loading" class="my-4">
                  <v-progress-linear
                    :indeterminate="loading"
                    :class="{ 'no-opacity': !loading }"
                    style="height: 2px;"
                  ></v-progress-linear>
                  <div class="text-center mt-4">Please Wait...</div>
                </div>
                <template v-else>
                  <v-text-field
                    autofocus
                    label="Search Address"
                    id="pac-input"
                    type="text"
                    clearable
                    autocomplete="off"
                    placeholder="Start Typing Here"
                  ></v-text-field>
                  <div 
                    class="google-map elevation-3" 
                    :id="mapName"
                  ></div>
                  <div id="infowindow-content">
                    <img src="" width="16" height="16" id="place-icon" alt="" />
                    <span id="place-name" class="title"></span><br />
                    <span id="place-address"></span>
                  </div>
                </template>
              </div>
              <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="viewOnMapDialog = false">Close</v-btn>
                  <v-btn
                    v-if="!loading"
                    color="primary"
                    @click="save"
                    >Ok
                  </v-btn>
              </v-card-actions>
          </div>
      </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SearchAddress',
  data() {
    return {
      areas: [],
      items_id: [],
      options: [],
      place: null,
      field: null,
      locationSearchText: null,
      loading: false,
      no_data: [null, '', undefined, 'null'],
      viewOnMapDialog: false,
      mapName: "search-address-map",
      markers: {},
      unsubscribe: null
    }
  },
  mounted() {
    this.unsubscribe = this.$store.subscribeAction(action => {
      if (action.type === 'vEmit' && action.payload.name === 'SearchAddress') {
          this.openModal(action.payload.data)
      }
    })
  },
  beforeDestroy() {
    this.unsubscribe()
  },
  methods: {
    edit(index) {
      this.$emit('edit', index)
    },
    remove(index) {
      this.$emit('edit', index)
    },
    titleCase(str){
      return _.startCase(str.replace(/_/g, ' '));
    },
    openModal(item) {
      this.viewOnMapDialog = true
      this.place = null
      this.field = item
      this.loading = true
      this.getLocation()
        .then(data => {
          this.loading = false
          setTimeout(() => {
            this.initMap(data)
          }, 100)
        })
    },
    getUserLocation () {
      const defaultOptions = {
        center: { lat: 41.850033, lng: -87.6500523 },
        zoom: 3
      }
      return new Promise(resolve => {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(function (position) {
            defaultOptions.center.lat = position.coords.latitude
            defaultOptions.center.lng = position.coords.longitude
            defaultOptions.zoom = 8
            resolve(defaultOptions)
          }, function (error) {
            console.log(error)
            resolve(defaultOptions)
          })
        } else {
          resolve(defaultOptions)
        }
      })
    },
    getLocation () {
      const defaultOptions = {
        center: { lat: 41.850033, lng: -87.6500523 },
        zoom: 3
      }
      return new Promise(resolve => {
        const address = this.user.organization_zip
        const geocoder = new google.maps.Geocoder()
        geocoder.geocode({ address }, function(results, status) {
          if (status == google.maps.GeocoderStatus.OK) {
            defaultOptions.center.lat = results[0].geometry.location.lat()
            defaultOptions.center.lng = results[0].geometry.location.lng()
            defaultOptions.zoom = 8
            resolve(defaultOptions)
          } else {
            resolve(defaultOptions)
          }
        })
      });
    },
    initMap(options) {
      const map = new google.maps.Map(document.getElementById(this.mapName), options);
      const input = document.getElementById("pac-input");
      const autocomplete = new google.maps.places.Autocomplete(input);
      autocomplete.bindTo("bounds", map);
      autocomplete.setFields(["address_components", "geometry", "icon", "name"]);
      const infowindow = new google.maps.InfoWindow();
      const infowindowContent = document.getElementById("infowindow-content");
      infowindow.setContent(infowindowContent);
      const marker = new google.maps.Marker({
        map,
        anchorPoint: new google.maps.Point(0, -29),
      });
      autocomplete.addListener("place_changed", () => {
        infowindow.close();
        marker.setVisible(false);
        const place = autocomplete.getPlace();

        if (!place.geometry) {
          // window.alert("No details available for input: '" + place.name + "'");
          return;
        }

        if (place.geometry.viewport) {
          map.fitBounds(place.geometry.viewport);
        } else {
          map.setCenter(place.geometry.location);
          map.setZoom(17);
        }
        marker.setPosition(place.geometry.location);
        marker.setVisible(true);
        let address = "";

        if (place.address_components) {
          this.place = _.cloneDeep(place)
          address = [
            (place.address_components[0] &&
              place.address_components[0].short_name) ||
              "",
            (place.address_components[1] &&
              place.address_components[1].short_name) ||
              "",
            (place.address_components[2] &&
              place.address_components[2].short_name) ||
              "",
          ].join(" ");
        }
        infowindowContent.children["place-icon"].src = place.icon;
        infowindowContent.children["place-name"].textContent = place.name;
        infowindowContent.children["place-address"].textContent = address;
        infowindow.open(map, marker);
      });
    },
    save () {
      let street_number = this.place.address_components.some(i => i.types.includes("street_number")) ? this.place.address_components.find(i => i.types.includes("street_number")).long_name : ''
      let street = this.place.address_components.some(i => i.types.includes("route")) ? this.place.address_components.find(i => i.types.includes("route")).long_name : ''
      let city = this.place.address_components.some(i => i.types.includes("locality")) ? this.place.address_components.find(i => i.types.includes("locality")).long_name : ''
      let state = this.place.address_components.some(i => i.types.includes("administrative_area_level_1")) ? this.place.address_components.find(i => i.types.includes("administrative_area_level_1")).long_name : ''
      let zip_code = this.place.address_components.some(i => i.types.includes("postal_code")) ? this.place.address_components.find(i => i.types.includes("postal_code")).long_name : ''
      let response = {
        field: this.field,
        address: `${!this.no_data.includes(street_number) ? street_number + ' ' : ''}${street}`,
        city,
        state,
        zip_code,
      }
      this.$emit('done', response)
      this.viewOnMapDialog = false
    }
  },
  computed: {
    ...mapGetters(["user"]),
  }
}
</script>

<style scoped>
  .google-map {
      width: 100%;
      height: 300px;
      height: 40vh;
      margin: 0 auto;
      background: #e5e3df;
  }

  #description {
    font-family: Roboto;
    font-size: 15px;
    font-weight: 300;
  }

  #infowindow-content #place-icon {
    margin-right: 4px;
  }

  #infowindow-content #place-name.title {
    font-weight: bold;
    font-size: 16px!important;
  }

  #infowindow-content {
    display: none;
  }

  #search-address-map #infowindow-content {
    display: inline;
  }

</style>
